export const SET_SELECTED_FREQUENCY_TREND_SIGNAL = "SET_SELECTED_FREQUENCY_TREND_SIGNAL";
export const FETCH_FREQUENCY_TREND_SIGNAL_SETTINGS = "FETCH_FREQUENCY_TREND_SIGNAL_SETTINGS";
export const SET_LOADING_FREQUENCY_TREND_SIGNAL = "SET_LOADING_FREQUENCY_TREND_SIGNAL";
export const SET_AVAILABLE_FREQUENCY_TREND_SIGNAL = "SET_AVAILABLE_FREQUENCY_TREND_SIGNAL";
export const SET_SELECTED_TREND_SIGNAL_SETTINGS = "SET_SELECTED_TREND_SIGNAL_SETTINGS";
export const GET_FREQUENCY_TREND_SIGNAL_SETTINGS = "GET_FREQUENCY_TREND_SIGNAL_SETTINGS";
export const SET_IS_TREND_SETTINGS_LOADING = "SET_IS_TREND_SETTINGS_LOADING";
export const SET_AVAILABLE_SIGNALS = "SET_AVAILABLE_SIGNALS";
export const CLEAR_AVAILABLE_SIGNALS = "CLEAR_AVAILABLE_SIGNALS";
export const ON_TOGGLE_SIGNAL = "ON_TOGGLE_SIGNAL";
export const ON_CUSTOM_DOMAIN_COMPARISON = "ON_CUSTOM_DOMAIN_COMPARISON";
export const RESET_STATE = "RESET_STATE";
export const SET_COMMON_GROUP_EXPANDED = "SET_COMMON_GROUP_EXPANDED";
export const SET_DISTINCT_GROUP_EXPANDED = "SET_DISTINCT_GROUP_EXPANDED";
export const TOGGLE_COMMON_GROUP_EXPANDED = "TOGGLE_COMMON_GROUP_EXPANDED";
export const TOGGLE_DISTINCT_GROUP_EXPANDED = "TOGGLE_DISTINCT_GROUP_EXPANDED";
export const ON_TOGGLE_DISTINCT_ASSET_GROUP = "ON_TOGGLE_DISTINCT_ASSET_GROUP";
export const SET_DISTINCT_ASSET_GROUP = "SET_DISTINCT_ASSET_GROUP";
export const SHOW_GLOBAL_SIGNAL_NAME_DIALOG = "SHOW_GLOBAL_SIGNAL_NAME_DIALOG";
export const CLOSE_GLOBAL_SIGNAL_NAME_DIALOG = "CLOSE_GLOBAL_SIGNAL_NAME_DIALOG";
export const SET_SHOW_SIGNAL_NAME_DIALOG = "SET_SHOW_SIGNAL_NAME_DIALOG";
export const LOAD_FREQUENCY_TREND_SIGNALS     = "LOAD_FREQUENCY_TREND_SIGNALS";
export const SHOW_TOAST_MESSAGE     = "SHOW_TOAST_MESSAGE";
export const SET_MENU_OPENED = "SET_MENU_OPENED";
export const SET_NO_DATA_AVAILABLE = "SET_NO_DATA_AVAILABLE";
export const SET_FILTER_TEXT = "SET_FILTER_TEXT";
export const DESELECT_ALL_SIGNALS = "DESELECT_ALL_SIGNALS";
export const CLEAR_SELECTED_FREQUENCY_TREND_SIGNALS = "CLEAR_SELECTED_FREQUENCY_TREND_SIGNALS";
export const GET_FREQUENCY_SIGNAL_SETTING_BY_ROUTE_ID = "GET_FREQUENCY_SIGNAL_SETTING_BY_ROUTE_ID";